function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9643 0H3.0357C1.35995 0.00199219 0.00199219 1.35995 0 3.0357V13.9643C0.00199219 15.64 1.35995 16.998 3.0357 17H13.9643C15.64 16.998 16.998 15.64 17 13.9643V3.0357C16.998 1.35995 15.64 0.00199219 13.9643 0ZM15.7857 13.9643C15.7857 14.9702 14.9702 15.7857 13.9643 15.7857H3.0357C2.02975 15.7857 1.21427 14.9702 1.21427 13.9643V3.0357C1.21427 2.02975 2.02975 1.21427 3.0357 1.21427H13.9643C14.9702 1.21427 15.7857 2.02975 15.7857 3.0357V13.9643Z",
  fill: "#249AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.536 7.89316H9.10743V5.46458C9.10743 5.12925 8.83561 4.85742 8.50028 4.85742C8.16495 4.85742 7.89312 5.12925 7.89312 5.46458V7.89316H5.46458C5.12925 7.89316 4.85742 8.16498 4.85742 8.50031C4.85742 8.83564 5.12925 9.10743 5.46458 9.10743H7.89316V11.536C7.89316 11.8713 8.16499 12.1432 8.50031 12.1432C8.83564 12.1432 9.10743 11.8713 9.10743 11.536V9.10743H11.536C11.8713 9.10743 12.1432 8.8356 12.1432 8.50028C12.1432 8.16495 11.8713 7.89316 11.536 7.89316Z",
  fill: "#249AF3"
});

function SvgPlustSquareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlustSquareIcon);
export default __webpack_public_path__ + "static/media/PlustSquareIcon.953102f4.svg";
export { ForwardRef as ReactComponent };